import PropTypes from "prop-types";

import ImageWithPreviewModal from "@/modules/image-with-preview-modal";

const HeaderLogo = ({ path }) => {
  return (
    <ImageWithPreviewModal data-testid="header-logo" height={65} src={path} />
  );
};

HeaderLogo.propTypes = {
  path: PropTypes.string.isRequired,
};

export default HeaderLogo;
